import { Component, Input } from '@angular/core';
import { TransactionLedgerTotals } from 'src/app/data/model/transaction-ledger';
import { emptyLedgerTotals, formatMoney } from './transaction-row.util';

/**
 * The figures under the ledger (SD-1227: shared by the Transactions screen and a report's
 * coding view).
 *
 * 'statement' is an account's statement for the period: opening, money out and in, closing.
 * 'report' has no opening or closing -- a report is a set of transactions, not a period of an
 * account -- so it shows how much of it is coded instead.
 */
@Component({
  selector: 'app-transactions-footer',
  templateUrl: './transactions-footer.component.html',
  styleUrls: ['./transactions-footer.component.scss']
})
export class TransactionsFooterComponent {
  @Input() mode: 'statement' | 'report' = 'statement';
  @Input() totals: TransactionLedgerTotals = emptyLedgerTotals();
  /** The sentence on the left. */
  @Input() status = '';

  money(value: number): string {
    return formatMoney(value);
  }

  get codedCount(): number {
    return (this.totals && this.totals.reconciledCount) || 0;
  }

  get totalCount(): number {
    return (this.totals && this.totals.periodCount) || 0;
  }
}
